'use strict'

export class AbstractError extends Error {}

export class ArgumentError extends AbstractError {}
